import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.47 7.42h-.85l-.01-4.69a.53.53 0 0 0-.52-.52H1.53c-.28 0-.5.22-.5.5v9.06c0 .28.24.52.52.52h6.27v1H5.88c-.28 0-.5.22-.5.5s.22.5.5.5h4.88c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H8.82v-1h2.82v3.33c0 .28.22.5.5.5h4.33c.28 0 .5-.22.5-.5v-7.7c0-.27-.23-.5-.5-.5zM2.03 11.29V3.22H14.6l.01 4.21h-2.48c-.28 0-.5.22-.5.5v3.37h-9.6zm13.94 3.84h-3.33v-6.7h3.33v6.7z"
    }, null, -1),
    _createElementVNode("circle", {
      fill: "currentColor",
      cx: "14.33",
      cy: "14.38",
      r: ".39"
    }, null, -1)
  ])))
}
export default { render };